export { default } from './part-window-view-slider';
